import React, { useEffect, useState } from 'react';
import { API_BASE } from '../config/api';

// Exam-page footer branding. For a student/teacher who belongs to a center, shows
// that center's logo + name (replacing the default "Developed by IELTS TA JUN").
export default function ExamWatermark() {
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch(`${API_BASE}/student/center-branding`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d && d.branding) setBranding(d.branding); })
      .catch(() => {});
  }, []);

  if (branding) {
    const logo = branding.logo_url
      ? (branding.logo_url.startsWith('http') ? branding.logo_url : `${API_BASE}${branding.logo_url}`)
      : null;
    return (
      <div className="flex items-center gap-2 mr-4">
        {logo && <img src={logo} alt="logo" className="h-9 w-9 rounded object-contain bg-white/80" />}
        <span className="font-bold text-base text-[#0096b1] leading-tight max-w-[180px] truncate">{branding.name}</span>
      </div>
    );
  }

  return (
    <div className="flex flex-col mr-4">
      <span className="text-red-600 font-bold text-sm">Developed by</span>
      <span className="text-red-600 font-bold text-lg leading-none">IELTS TA JUN</span>
    </div>
  );
}
